import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

export default function SignInSecurity() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/platform/security").then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  if (!s) return <p className="text-sm text-slate-500">Loading...</p>;
  const set = async (on) => {
    if (!on && !window.confirm("Turn OFF 2-step verification for every staff account on all organizations? Use only for training and testing with no real patient data.")) return;
    setBusy(true);
    try {
      const { data } = await api.put("/platform/security", { new_device_code: on });
      toast[data.failed_users ? "warning" : "success"](data.failed_users ? `Saved, but ${data.failed_users} account(s) could not be updated - try again` : on ? "2-step verification turned ON" : "2-step verification turned OFF");
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const on = s.new_device_code;
  return (
    <div className="bg-white border rounded-xl p-5 max-w-2xl space-y-4" data-testid="sign-in-security">
      <div><h2 className="text-lg font-semibold">Sign-in security</h2>
        <p className="text-sm text-slate-600">Applies to every staff account on the platform (all organizations).</p></div>
      <div className={`flex items-start gap-3 rounded-lg border p-4 ${on ? "border-emerald-300 bg-emerald-50" : "border-amber-300 bg-amber-50"}`}>
        {on ? <ShieldCheck className="w-6 h-6 text-emerald-700 shrink-0" /> : <ShieldOff className="w-6 h-6 text-amber-700 shrink-0" />}
        <div className="flex-1">
          <p className="font-semibold">2-step verification (email code on a new device or browser)</p>
          <p className="text-sm text-slate-700 mt-1">{on ? "ON - after the password, staff signing in from a new device or browser must enter a code sent to their email." : "OFF - staff sign in with email and password only. Use only for training and testing with no real patient data."}</p>
          <p className="text-xs text-slate-500 mt-2" data-testid="sign-in-security-status">Status: {on ? "On" : "Off"} - {s.users_applied}/{s.users_total} accounts updated{s.updated_by ? ` - last changed by ${s.updated_by}` : ""}</p>
        </div>
        <Switch checked={on} disabled={busy} onCheckedChange={set} aria-label="2-step verification" data-testid="two-step-switch" />
      </div>
      {s.users_applied < s.users_total && <Button variant="outline" size="sm" disabled={busy} onClick={() => set(on)} data-testid="two-step-reapply">Apply to all accounts again</Button>}
    </div>
  );
}
